import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';

const Impressum = () => {
    const { t } = useTranslation();

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header */}
            <div className="bg-white border-b border-gray-200 pt-24">
                <div className="container-custom py-16">
                    <div className="max-w-3xl">
                        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                            {t('imprint.title')}
                        </h1>
                        <p className="text-xl text-gray-600 leading-relaxed">
                            {t('imprint.description')}
                        </p>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="container-custom py-16">
                <div className="max-w-4xl mx-auto">
                    <div className="bg-white rounded-2xl border border-gray-200 p-8 md:p-12">
                        <div className="space-y-8">
                            {/* Company Information */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    {t('imprint.companyInfo')}
                                </h3>
                                <div className="text-gray-600 leading-relaxed">
                                    <p className="font-medium">{t('imprint.companyName')}</p>
                                    <div className="whitespace-pre-line mt-2">
                                        {t('imprint.address')}
                                    </div>
                                </div>
                            </section>

                            {/* Contact */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    {t('imprint.contact')}
                                </h3>
                                <div className="text-gray-600 leading-relaxed space-y-1">
                                    <p>{t('imprint.phone')}</p>
                                    <p>{t('imprint.email')}</p>
                                    <p>{t('imprint.web')}</p>
                                </div>
                            </section>

                            {/* Legal Information */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    {t('imprint.legalInfo')}
                                </h3>
                                <div className="text-gray-600 leading-relaxed space-y-1">
                                    <p>{t('imprint.managingDirector')}</p>
                                    <p>{t('imprint.registrationCourt')}</p>
                                    <p>{t('imprint.commercialRegister')}</p>
                                    <p>{t('imprint.vatId')}</p>
                                    <p>{t('imprint.fiscalCode')}</p>
                                    <p>{t('imprint.recipientCode')}</p>
                                    <p>{t('imprint.economicRegistry')}</p>
                                </div>
                            </section>

                            {/* Business Activity */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    {t('imprint.businessActivity')}
                                </h3>
                                <p className="text-gray-600 leading-relaxed">
                                    {t('imprint.businessActivityText')}
                                </p>
                            </section>

                            {/* Authorizations */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    {t('imprint.authorizations')}
                                </h3>
                                <p className="text-gray-600 leading-relaxed">
                                    {t('imprint.authorizationsText')}
                                </p>
                            </section>

                            {/* Data Protection Officer */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    Datenschutzbeauftragter / Responsabile Protezione Dati / Data Protection Officer
                                </h3>
                                <p className="text-gray-600 leading-relaxed">
                                    {t('imprint.dataProtectionOfficer')}
                                </p>
                            </section>

                            {/* Copyright */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    {t('imprint.copyrightNotice')}
                                </h3>
                                <p className="text-gray-600 leading-relaxed">
                                    {t('imprint.copyrightText')}
                                </p>
                            </section>

                            {/* Dispute Resolution */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    {t('imprint.disputeResolution')}
                                </h3>
                                <p className="text-gray-600 leading-relaxed">
                                    {t('imprint.disputeResolutionText')}
                                </p>
                            </section>

                            {/* Disclaimer */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    {t('imprint.disclaimer')}
                                </h3>
                                <p className="text-gray-600 leading-relaxed">
                                    {t('imprint.disclaimerText')}
                                </p>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Impressum;
